<template>
  <b-modal
    id="showPricingSchedule"
    ref="showPricingSchedule"
    :title="modalText"
    @shown="fetchPricingSchedules"
    @ok="closeModal"
    ok-only
    ok-title="Cancel"
    size="xl"
  >
    <v-wait for="fetchingPricingSchedules">
      <template slot="waiting">
        <content-placeholders :rounded="true">
          <content-placeholders-text :lines="20"></content-placeholders-text>
        </content-placeholders>
      </template>
      <div class="row">
        <div class="col-sm-2 mb-2 align-content-center">
          Show only:
        </div>
        <div class="col-sm-3 mb-2 align-content-center">
          <b-form-checkbox
            id="enterprisePricing"
            name="Enterprise Pricing"
            ref="enterprisePricing"
            class=" rounded d-inline b-0 pr-2 mb-1"
            v-model="enterprisePricingFilterOn"
            @input="setFilter(null)"
            :value="true"
            :unchecked-value="false"
          >
            <span class="col-form-label">Enterprise Pricing</span>
          </b-form-checkbox>
        </div>
        <div class="col-sm-4 mb-2 align-content-center">
          <b-form-checkbox
            id="productAccess"
            name="Product Access"
            ref="productAccess"
            class=" rounded d-inline b-0 pr-2 mb-1"
            v-model="productAccessFilterOn"
            @input="setFilter(null)"
            :value="true"
            :unchecked-value="false"
          >
            <span class="col-form-label">Product Access</span>
          </b-form-checkbox>
        </div>
        <div class="col-sm-3 mb-3 align-content-center">
          <b-input-group>
            <div class="input-group-prepend">
              <button type="button" class="btn btn-secondary">
                <i class="fa fa-search"></i>
              </button>
            </div>
            <b-form-input
              type="text"
              v-model="filterSearch"
              @update="setFilter(filterSearch)"
              placeholder="Search"
              ref="search"
            ></b-form-input>
          </b-input-group>
        </div>
      </div>
      <b-table
        striped
        :items="pricingSchedules"
        :fields="fields"
        :filter="filter"
        caption-top
        responsive
        show-empty
        empty-text="No Pricing Schedule Available"
      >
      </b-table>
    </v-wait>
  </b-modal>
</template>

<script charset="utf-8">
// api
import clientPricingScheduleAPI from '@/api/finapps/super_admin/client_pricing_schedules'

export default {
  name: 'ShowPricingSchedule',
  props: {
    selectedPricingSchedule: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fields: [
        { key: 'product', label: 'Product', sortable: true },
        { key: 'key', label: 'Key', sortable: true },
        { key: 'range_element', label: 'Range Element', sortable: true },
        { key: 'range_min', label: 'Range Min', sortable: true },
        { key: 'range_max', label: 'Range Max', sortable: true },
        { key: 'value', label: 'Value', sortable: true }
      ],
      pricingSchedules: [],
      filter: null,
      enterprisePricingFilterOn: false,
      productAccessFilterOn: false,
      filterSearch: null
    }
  },
  computed: {
    modalText() {
      return (
        this.selectedPricingSchedule.group_name + ' Client Pricing Schedule'
      )
    }
  },
  methods: {
    setFilter(value) {
      if (this.enterprisePricingFilterOn && this.productAccessFilterOn) {
        this.filter = value
          ? new RegExp('is_fin|enterprise|is_mbc|' + value)
          : new RegExp('is_fin|enterprise|is_mbc')
      } else if (this.enterprisePricingFilterOn) {
        this.filter = value
          ? new RegExp('enterprise|is_mbc|' + value)
          : new RegExp('enterprise|is_mbc')
      } else if (this.productAccessFilterOn) {
        this.filter = value
          ? new RegExp('is_fin|' + value)
          : new RegExp('is_fin')
      } else if (
        !this.enterprisePricingFilterOn &&
        !this.productAccessFilterOn
      ) {
        this.filter = value ? value : ''
      }
    },
    fetchPricingSchedules() {
      this.$wait.start('fetchingPricingSchedules')
      clientPricingScheduleAPI
        .pricingSchedules(this.selectedPricingSchedule.group_id)
        .then(res => {
          this.pricingSchedules = res
            ? res.client_pricing_schedule.pricing_schedules
            : null
          this.$wait.end('fetchingPricingSchedules')
        })
    },
    closeModal() {
      this.$bvModal.hide('showPricingSchedule')
    }
  }
}
</script>
